import { Link } from "react-router-dom";
import { genres } from "@/mocks/films";

const Footer = () => (
  <footer className="bg-foreground-950 text-background-200">
    <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-sm font-bold text-foreground-950">
              色
            </span>
            <span className="font-heading text-[17px] font-bold tracking-wide text-background-50">
              色即是空
            </span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300/80">
            一个关于经典影视作品的资料站。我们整理作品信息、剧情脉络与演员档案，
            用可以查证的资料陪你把一部片子看得更仔细一点。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-900 text-background-200">
              <i className="ri-mail-line" />
            </span>
            <span className="font-label text-sm text-background-200">archive@sejishikong.film</span>
          </div>
        </div>
        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">浏览</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/" className="transition-colors hover:text-accent-400">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category" className="transition-colors hover:text-accent-400">
                影视分类
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-accent-400">
                检索资料
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-accent-400">
                关于我们
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">热门分类</h4>
          <ul className="space-y-2.5 text-sm">
            {genres.slice(0, 5).map((genre) => (
              <li key={genre}>
                <Link
                  to={`/category?genre=${encodeURIComponent(genre)}`}
                  className="transition-colors hover:text-accent-400"
                >
                  {genre}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-3 border-t border-foreground-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
        <p>© 2026 色即是空 影视资料站 · 内容仅供学习与研究参考</p>
        <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <span className="whitespace-nowrap">资料勘误：archive@sejishikong.film</span>
          <span className="whitespace-nowrap">站长不提供影片下载</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;